module.exports = __webpack_public_path__ + "static/img/侧边栏.ed0d780.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/侧边栏.png
// module id = oVI8
// module chunks = 0